(() => {
  const PID='15566418084215';
  function picker(g){return (g.closest('.shopify-section')||document).querySelector('variant-picker[data-product-id="'+PID+'"]')}
  function setVariant(g,i){
    if(i<0||i>3)return;
    const p=picker(g); if(!p)return;
    const value='Foto '+(i+1);
    const r=[...p.querySelectorAll('input[type="radio"]')].find(x=>x.value===value);
    if(r&&!r.checked){r.click();return}
    const s=[...p.querySelectorAll('select')].find(x=>[...x.options].some(o=>o.value===value));
    if(s&&s.value!==value){s.value=value;s.dispatchEvent(new Event('change',{bubbles:true}))}
  }
  function bind(g){
    if(g.dataset.cpGteSync)return;
    if(!picker(g))return;
    const s=g.querySelector('slideshow-component');if(!s)return;
    g.dataset.cpGteSync='1';
    let last=-1;
    const sync=()=>{
      const slides=[...s.querySelectorAll('slideshow-slide')].filter(x=>!x.hidden);
      let i=slides.findIndex(x=>x.getAttribute('aria-hidden')==='false');
      if(i<0&&Number.isInteger(s.current))i=s.current;
      if(i>=0&&i!==last){last=i;setVariant(g,i)}
    };
    new MutationObserver(sync).observe(s,{subtree:true,attributes:true,attributeFilter:['aria-hidden']});
    s.addEventListener('slideshow:select',e=>{const i=Number(e.detail&&e.detail.index);if(Number.isInteger(i)){last=i;setVariant(g,i)}});
  }
  const init=()=>document.querySelectorAll('media-gallery').forEach(bind);
  init();new MutationObserver(init).observe(document.documentElement,{childList:true,subtree:true});
})();